const ErrorFallback = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Something went wrong</h1>
    <p>We have been notified and are looking into it.</p>
    <button onClick={() => window.location.reload()}>Reload page</button>
  </div>
);

export default ErrorFallback;
